import { io } from 'socket.io-client';

// Use the environment variable, fallback to localhost only for development
const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  'https://urlshortener-serverside.onrender.com';

// Initialize socket connection
const socket = io(BACKEND_URL, {
  withCredentials: true, // Allow authentication cookies if needed
  transports: ['websocket', 'polling'], // Support different connection methods
});

socket.on('connect', () => {
  console.log('Connected to WebSocket:', socket.id);
});

socket.on('disconnect', () => {
  console.log('Disconnected from WebSocket');
});

export default socket;
